/* eslint-disable no-console */
import {InfoCircleOutlined} from '@ant-design/icons';
import {Col, Form, Input, Select} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import moment from 'moment';
import React, {useContext, useEffect, useState} from 'react';

import {ReactComponent as YearCalender} from '../../assets/yearCalender.svg';
import {CommonErrors} from '../../constants/Common';
import FilteredUnit from '../../constants/FilteredUnit';
import InformativeText from '../../constants/InformativeText';
import SelectedCountryContext from '../../pages/configurator/orgFacility/Constants/SelectedCountryContext';
import {sortYearOptions} from '../../pages/orgManager/Utils/InfraStructureProfile/constant/sorYear';
import NumberInput from '../../shared/NumberInput';
import yearFilterArray from '../../shared/YearFilterArray';
import workingDaysOfWeek from '../../staticJson/workingDaysOfWeek.json';
import useCompanyStore from '../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../store/StaticJson/jsonStore';
import {hasUserRole, UserRole} from '../../utils/commonFunctions';
import {FirstCap} from '../../utils/FormUtils/FirstCap';
import RegEx from '../../utils/FormUtils/RegEx';
import PhoneNumberInput from '../CustomInputs/PhoneNumberInput/PhoneNumberInput';
import MomentDatePicker from '../DatePicker/MomentDatePicker';

import {facilityKeyLabel, yearKeyLabel} from './Constants/IP/commonKeyLabel';
import {EmpKey, EmpLabel} from './Constants/IP/EmpKeyLabel';
import {filterSelectOptions} from './Utils/commonFunctions';

const EmpForm: React.FC<{
  isConfigurator?: boolean;
  currentStep?: number;
}> = ({isConfigurator, currentStep}) => {
  const isCompanyUserOrAdmin =
    hasUserRole(UserRole.Company_Admin) || hasUserRole(UserRole.Company_user);
  const modeOfTransport = useJSONStore((state) => state.modeOfTransportTrav);
  const facilityDetails = useCompanyStore.getState().facilityDetails;
  const {efdbData, facilityId, selectedYear, selectedCountry} = useContext(
    SelectedCountryContext
  );
  const FormInstance = useFormInstance();
  const {setFields, getFieldValue} = FormInstance;
  // );
  const [homeAdd, setHomeAdd] = useState(
    getFieldValue(EmpKey.HOME_ADD) ?? undefined
  );
  const [offAdd, setOffAdd] = useState(
    getFieldValue(EmpKey.OFFICE_ADD) ?? undefined
  );
  const [facilityEfdb, setFacilityEfdb] = useState<any>();

  const [yearOptions, setYearOptions] = useState<any[]>([]);

  useEffect(() => {
    setYearOptions(yearFilterArray(facilityDetails, undefined, false));
  }, []);

  const empInfo = InformativeText?.IP?.travel?.emp;
  const [formSelectedCountry, setFormSelectedCountry] = useState<string>('');
  const [facilityOpt, setFacilityOpt] = useState<any[]>([]);
  useEffect(() => {
    setFacilityOpt(
      facilityDetails?.[
        getFieldValue(yearKeyLabel.key) ?? selectedYear ?? ''
      ]?.filter((item: any) => {
        return !item.isLeased;
      }) ?? []
    );
    setFacilityEfdb(
      efdbData?.[getFieldValue(yearKeyLabel.key) ?? selectedYear ?? '']?.find(
        (i: any) => {
          return (
            i.facilityId === (getFieldValue(facilityKeyLabel.key) ?? facilityId)
          );
        }
      )
    );
  }, []);

  useEffect(() => {
    setFormSelectedCountry(
      facilityOpt.find((item: any) => {
        return (
          item?._id === (getFieldValue(facilityKeyLabel.key) ?? facilityId)
        );
      })?.country
    );
  }, [facilityOpt]);

  const designationOptions = useJSONStore.getState().designation;
  const genderOptions = useJSONStore.getState().gender;

  return (
    <>
      {currentStep === 0 && (
        <>
          <Col className="gutter-row">
            <Form.Item
              name={yearKeyLabel.key}
              label={yearKeyLabel.label}
              labelCol={{span: 24}}
              initialValue={selectedYear}
            >
              <Select
                placeholder={yearKeyLabel.label}
                options={sortYearOptions(yearOptions)}
                suffixIcon={<YearCalender />}
                disabled={
                  !isConfigurator ? getFieldValue('_id') !== undefined : false
                }
                onChange={(e) => {
                  setFacilityOpt(
                    facilityDetails?.[e]?.filter((item: any) => {
                      return !item.isLeased;
                    }) ?? []
                  );
                  setFacilityEfdb(() => {
                    return efdbData?.[e]?.find((i: any) => {
                      return (
                        i?.facilityId === getFieldValue(facilityKeyLabel.key)
                      );
                    });
                  });
                  if (getFieldValue(facilityKeyLabel.key)) {
                    setFields([
                      {
                        name: facilityKeyLabel.key,
                        value: undefined,
                        errors: ['Please select facility again']
                      }
                    ]);
                  }
                }}
              />
            </Form.Item>
          </Col>
          {isCompanyUserOrAdmin && (
            <>
              <Col className="gutter-row">
                <Form.Item
                  name={facilityKeyLabel.key}
                  label={facilityKeyLabel.label}
                  labelCol={{span: 24}}
                  rules={[
                    {
                      required: true,
                      message: CommonErrors.mandatory(facilityKeyLabel.label)
                    }
                  ]}
                  initialValue={facilityId}
                >
                  <Select
                    placeholder={facilityKeyLabel.label}
                    disabled={
                      !isConfigurator
                        ? getFieldValue('_id') !== undefined
                        : false
                    }
                    options={
                      facilityOpt?.map((item: any) => {
                        return {label: item.name, value: item._id};
                      }) ?? []
                    }
                    onChange={(e) => {
                      setFacilityEfdb(() => {
                        return efdbData?.[
                          getFieldValue(yearKeyLabel.key)
                        ]?.find((i: any) => {
                          return i?.facilityId === e;
                        });
                      });
                      setFormSelectedCountry(
                        facilityDetails?.[
                          getFieldValue(yearKeyLabel.key) ?? ''
                        ]?.find((item: any) => {
                          return item._id === e;
                        })?.country
                      );
                    }}
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </>
      )}
      {currentStep === 1 && (
        <>
          <Col className="gutter-row">
            <Form.Item
              name={EmpKey.FIRST_NAME}
              label={EmpLabel.FIRST_NAME}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(EmpLabel.FIRST_NAME)
                },
                {
                  max: 100,
                  message: `${EmpLabel.FIRST_NAME} Should not be more than 100 Characters`
                },
                {
                  min: 2,
                  message: `${EmpLabel.FIRST_NAME} Should be more than 1 Characters`
                },
                {
                  pattern: RegEx.names,
                  message:
                    'No special characters , Empty spaces or Numbers are Allowed'
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <Input
                onInput={(e) => {
                  const target = e.target as HTMLInputElement;
                  target.value = FirstCap(target.value);
                }}
                placeholder={`Enter ${EmpLabel.FIRST_NAME}`}
                disabled={
                  !isConfigurator ? getFieldValue('_id') !== undefined : false
                }
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name={EmpKey.LAST_NAME}
              label={EmpLabel.LAST_NAME}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(EmpLabel.LAST_NAME)
                },
                {
                  max: 100,
                  message: `${EmpLabel.LAST_NAME} Should not be more than 100 Characters`
                },
                // {
                //   min: 2,
                //   message: `${EmpLabel.LAST_NAME} Should be more than 1 Characters`
                // },
                {
                  pattern: RegEx.names,
                  message:
                    'No special characters , Empty spaces or Numbers are Allowed'
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <Input
                onInput={(e) => {
                  const target = e.target as HTMLInputElement;
                  target.value = FirstCap(target.value);
                }}
                placeholder={`Enter ${EmpLabel.LAST_NAME}`}
                disabled={
                  !isConfigurator ? getFieldValue('_id') !== undefined : false
                }
              />
            </Form.Item>
          </Col>
          {isConfigurator && (
            <Col>
              <Form.Item
                name={EmpKey.GENDER}
                label={EmpLabel.GENDER}
                rules={[
                  {
                    required: true,
                    message: CommonErrors.mandatory(EmpLabel.GENDER)
                  }
                ]}
                hasFeedback
                labelCol={{span: 24}}
              >
                <Select
                  placeholder={`Choose ${EmpLabel.GENDER}`}
                  options={genderOptions}
                  className="input"
                  filterOption={filterSelectOptions}
                  showSearch
                />
              </Form.Item>
            </Col>
          )}
          <Col className="gutter-row">
            <Form.Item
              name={EmpKey.EMP_CODE}
              label={EmpLabel.EMP_CODE}
              labelCol={{span: 24}}
              rules={[]}
              initialValue={''}
              validateFirst={true}
              hasFeedback
            >
              <Input
                onInput={(e) => {
                  const target = e.target as HTMLInputElement;
                  target.value = FirstCap(target.value);
                }}
                placeholder={`Enter ${EmpLabel.EMP_CODE}`}
                disabled={
                  !isConfigurator ? getFieldValue('_id') !== undefined : false
                }
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name={EmpKey.EMAIL}
              label={EmpLabel.EMAIL}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(EmpLabel.EMAIL)
                },
                {
                  min: 5,
                  message: `${EmpLabel.EMAIL} Should be more than 4 Characters`
                },
                {
                  max: 320,
                  message: `${EmpLabel.EMAIL} Should not be more than 320 Characters`
                },
                {
                  pattern: RegEx.email,
                  message: CommonErrors.validField(EmpLabel.EMAIL)
                }
              ]}
              initialValue={undefined}
              validateFirst={true}
              hasFeedback
            >
              <Input
                placeholder={`Enter ${EmpLabel.EMAIL}`}
                disabled={
                  !isConfigurator ? getFieldValue('_id') !== undefined : false
                }
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row">
            <Form.Item
              name={EmpKey.MOBILE}
              label={EmpLabel.MOBILE}
              labelCol={{span: 24}}
              rules={[
                // {
                //   required: true,
                //   message: CommonErrors.mandatory(EmpLabel.MOBILE)
                // },
                {
                  // eslint-disable-next-line @typescript-eslint/promise-function-async
                  validator(_, value) {
                    if (/^\+\d{4,}$/.test(value)) {
                      if (RegEx.mobile.test(value)) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject(
                          new Error(CommonErrors.validField(EmpLabel.MOBILE))
                        );
                      }
                    } else {
                      return Promise.resolve();
                    }
                  }
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <PhoneNumberInput
                disabled={
                  !isConfigurator ? getFieldValue('_id') !== undefined : false
                }
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name={EmpKey.DATE_JOINING}
              label={EmpLabel.DATE_JOINING}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(EmpLabel.DATE_JOINING)
                }
              ]}
              validateFirst={true}
              hasFeedback
              labelCol={{span: 24}}
            >
              <MomentDatePicker
                disabledDate={(current) => {
                  return moment() <= current;
                }}
                disabled={
                  !isConfigurator ? getFieldValue('_id') !== undefined : false
                }
                inputReadOnly
                format="DD-MM-YYYY"
                style={{width: '100%'}}
                showNow={false}
                onChange={() => {
                  if (getFieldValue(EmpKey.DATE_RESIGNING)) {
                    setFields([
                      {
                        name: EmpKey.DATE_RESIGNING,
                        errors: [CommonErrors.selectAgain],
                        value: undefined
                      }
                    ]);
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item dependencies={[EmpKey.DATE_JOINING]} noStyle>
              {({getFieldValue}) => (
                <Form.Item
                  name={EmpKey.DATE_RESIGNING}
                  label={EmpLabel.DATE_RESIGNING}
                  rules={
                    [
                      // {
                      //   required: true,
                      //   message: CommonErrors.mandatory(EmpLabel.DATE_JOINING)
                      // }
                    ]
                  }
                  validateFirst={true}
                  hasFeedback
                  labelCol={{span: 24}}
                >
                  <MomentDatePicker
                    disabledDate={(current) => {
                      const joiningDate = getFieldValue(EmpKey.DATE_JOINING);

                      return (
                        current.isAfter(moment(), 'day') ||
                        (joiningDate &&
                          current.isBefore(moment(joiningDate), 'day'))
                      );
                    }}
                    disabled={
                      !isConfigurator
                        ? getFieldValue('_id') !== undefined
                        : false
                    }
                    inputReadOnly
                    format="DD-MM-YYYY"
                    style={{width: '100%'}}
                    showNow={false}
                  />
                </Form.Item>
              )}
            </Form.Item>
          </Col>
          {isConfigurator && (
            <Col>
              <Form.Item
                name={EmpKey.DESIGNATION}
                label={EmpLabel.DESIGNATION}
                rules={[
                  {
                    required: true,
                    message: CommonErrors.mandatory(EmpLabel.DESIGNATION)
                  }
                ]}
                hasFeedback
                labelCol={{span: 24}}
              >
                <Select
                  placeholder={`Choose ${EmpLabel.DESIGNATION}`}
                  options={designationOptions}
                  className="input"
                  filterOption={filterSelectOptions}
                  showSearch
                />
              </Form.Item>
            </Col>
          )}

          {!isConfigurator && (
            <>
              <Col className="gutter-row">
                <Form.Item
                  name={EmpKey.WORKING_DAYS}
                  label={EmpLabel.WORKING_DAYS}
                  labelCol={{span: 24}}
                  rules={[
                    {
                      required: true,
                      message: CommonErrors.mandatory(EmpLabel.WORKING_DAYS)
                    }
                  ]}
                >
                  <Select
                    showSearch
                    className="select"
                    placeholder={`Choose ${EmpLabel.WORKING_DAYS}`}
                    filterOption={filterSelectOptions}
                    options={workingDaysOfWeek}
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row">
                <Form.Item
                  name={EmpKey.MODE}
                  label={EmpLabel.MODE}
                  labelCol={{span: 24}}
                  rules={[
                    {
                      required: true,
                      message: CommonErrors.mandatory(EmpLabel.MODE)
                    }
                  ]}
                >
                  <Select
                    showSearch
                    className="select"
                    placeholder={`Choose ${EmpLabel.MODE}`}
                    options={modeOfTransport.filter((item) => {
                      return item?.dbName === facilityEfdb?.scope3;
                    })}
                    filterOption={filterSelectOptions}
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row">
                <Form.Item
                  name={EmpKey.DISTANCE_TRAVELLED}
                  label={EmpLabel.DISTANCE_TRAVELLED}
                  rules={[
                    {
                      required: !homeAdd && !offAdd,
                      message: CommonErrors.mandatory(
                        EmpLabel.DISTANCE_TRAVELLED
                      )
                    },
                    {
                      pattern: RegEx.nonDecimal,
                      message: CommonErrors.nonDecimalNonNegative
                    }
                  ]}
                  labelCol={{span: 24}}
                  initialValue={null}
                  tooltip={{
                    icon: <InfoCircleOutlined />,
                    title: empInfo?.distanceTravelled
                  }}
                >
                  <NumberInput
                    placeholder={`Enter ${EmpLabel.DISTANCE_TRAVELLED}`}
                    // onChange={(e) => {
                    //   setDistanceTrav(e as number);
                    // }}
                    addonAfter={
                      FilteredUnit(formSelectedCountry ?? selectedCountry)
                        .distance
                    }
                    // disabled={homeAdd || offAdd}
                  />
                </Form.Item>
              </Col>

              <Col className="gutter-row">
                <Form.Item
                  name={EmpKey.HOME_ADD}
                  rules={[
                    {
                      required:
                        !FilteredUnit(formSelectedCountry ?? selectedCountry)
                          .distance || offAdd,
                      message: CommonErrors.mandatory(EmpLabel.HOME_ADD)
                    }
                  ]}
                  label={EmpLabel.HOME_ADD}
                  labelCol={{span: 24}}
                  initialValue={''}
                >
                  <Input
                    className="input"
                    placeholder={`Enter ${EmpLabel.HOME_ADD}`}
                    onInput={(e) => {
                      const target = e.target as HTMLInputElement;
                      target.value = FirstCap(target.value);
                    }}
                    // disabled={distanceTrav}
                    onChange={(e) => {
                      setHomeAdd(e.target.value);
                    }}
                  />
                </Form.Item>
              </Col>

              <Col className="gutter-row">
                <Form.Item
                  name={EmpKey.OFFICE_ADD}
                  rules={[
                    {
                      required:
                        !FilteredUnit(formSelectedCountry ?? selectedCountry)
                          .distance || homeAdd,
                      message: CommonErrors.mandatory(EmpLabel.OFFICE_ADD)
                    }
                  ]}
                  label={EmpLabel.OFFICE_ADD}
                  labelCol={{span: 24}}
                  initialValue={''}
                >
                  <Input
                    className="input"
                    placeholder={`Enter ${EmpLabel.OFFICE_ADD}`}
                    onInput={(e) => {
                      const target = e.target as HTMLInputElement;
                      target.value = FirstCap(target.value);
                    }}
                    // disabled={distanceTrav}
                    onChange={(e) => {
                      setOffAdd(e.target.value);
                    }}
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </>
      )}
    </>
  );
};

export default EmpForm;
